export default __webpack_public_path__ + "static/blob9-7dc3cdc81a7cfbe4758b8efe977ae1b6.svg";